const TITLE = "네 믿음대로 될지어다"
const CAMPAIGN_DATE = [
    "2025-02-24",
    "2025-02-25",
    "2025-02-26",
    "2025-02-27",
    "2025-03-03",
    "2025-03-04",
    "2025-03-05",
    "2025-03-06",
]
// const CAMPAIGN_DATE = [
//     "2025-02-24",
//     "2025-02-25",
//     "2025-02-26",
//     "2025-02-27",
//     "2025-03-03",
//     "2025-03-04",
//     "2025-03-05",
//     "2025-03-06",
// ]
export { TITLE, CAMPAIGN_DATE }